import { http } from "api/http";

const createRequestEvent = (data: any) => {
  return http.post("/request-events", data);
};

const updateRequestEvent = ({ id, data }: any) => {
  return http.put(`/request-events/${id}`, data);
};

const deleteRequestEvent = ({ id }: any) => {
  return http.delete(`/request-events/${id}`);
};

const getRequestEvents = ({ queryKey }) => {
  const [, params] = queryKey;
  return http.get("/request-events", { params });
};


// const getDefaultRequestEvents = ({ queryKey }) => {
//   return http.get("/events/default", { params: { ...queryKey[1] } });
// };

// Add this at the top of the file
type CalendarImageResponse = {
  image: string; // base64 string
};

const getCalendarImage = (
  params?: { month?: string },
  signal?: AbortSignal
) => {
  return http.get<CalendarImageResponse>(
    "/events/download-compliance-calendar",
    {
      params,
      signal, // 👈 pass the AbortSignal to axios
    }
  );
};

export { getRequestEvents, createRequestEvent, updateRequestEvent, deleteRequestEvent, getCalendarImage };
